module.exports = __webpack_public_path__ + "img/banner_mobile.18cdd17.png";